import { GOOGLEANALYTICS_ID } from "../env";

const GOOGLE_TAG_SCRIPT_ID = "portal-google-analytics-gtag";
const GA4_MEASUREMENT_ID_PATTERN = /^G-[A-Z0-9]+$/i;

let initializedMeasurementId = null;
let lastTrackedPagePath = null;

function getGoogleTag() {
  if (typeof window === "undefined") {
    return null;
  }

  window.dataLayer = window.dataLayer || [];

  if (!window.gtag) {
    window.gtag = function googleTag() {
      window.dataLayer.push(arguments);
    };
  }

  return window.gtag;
}

export function initializeGoogleAnalytics(
  measurementId = GOOGLEANALYTICS_ID
) {
  const normalizedMeasurementId = measurementId?.trim();

  if (!normalizedMeasurementId) {
    return false;
  }

  if (!GA4_MEASUREMENT_ID_PATTERN.test(normalizedMeasurementId)) {
    console.error("Identificador do Google Analytics inválido para o GA4.");
    return false;
  }

  if (initializedMeasurementId === normalizedMeasurementId) {
    return true;
  }

  if (initializedMeasurementId) {
    console.error("O Google Analytics já foi inicializado com outro identificador.");
    return false;
  }

  const googleTag = getGoogleTag();

  if (!googleTag) {
    return false;
  }

  if (!document.getElementById(GOOGLE_TAG_SCRIPT_ID)) {
    const script = document.createElement("script");
    script.id = GOOGLE_TAG_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
      normalizedMeasurementId
    )}`;
    document.head.appendChild(script);
  }

  googleTag("js", new Date());
  googleTag("config", normalizedMeasurementId, {
    send_page_view: false
  });

  initializedMeasurementId = normalizedMeasurementId;
  return true;
}

export function trackGoogleAnalyticsPageView(pagePath, pageTitle) {
  const googleTag = getGoogleTag();
  const normalizedPagePath = pagePath?.startsWith("/") ? pagePath : "/";

  if (
    !initializedMeasurementId ||
    !googleTag ||
    lastTrackedPagePath === normalizedPagePath
  ) {
    return false;
  }

  googleTag("event", "page_view", {
    page_location: new URL(normalizedPagePath, window.location.origin).toString(),
    page_path: normalizedPagePath,
    page_title: pageTitle || document.title
  });

  lastTrackedPagePath = normalizedPagePath;
  return true;
}
